import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Avatar } from 'antd';

import { getURL, parseStringOr } from '../App/AppxUtils';


class AppxLangAvatar extends React.Component {
    uri = null;

    constructor(props) {
        super(props);

        let url = getURL();
        this.uri = url?.searchParams || new URLSearchParams();

        let lang = parseStringOr(this.uri.get('lang'), "");
        const { i18n } = props;

        if (lang !== "") {
            lang = (lang === 'fr') ? 'fr' : 'en';
            i18n.changeLanguage(lang);
        }
        else {
            lang = i18n.language;
        }

        this.state = {
            currentLanguage: lang,
            altLngLabel: (lang === 'fr') ? 'En' : 'Fr'
        };

        this.changeLanguage = this.changeLanguage.bind(this);
    }

    async changeLanguage() {
        const { i18n } = this.props;

        if (this.state.currentLanguage === 'fr') {
            this.setState({
                currentLanguage: 'en',
                altLngLabel: 'Fr'
            });
        }
        else {
            this.setState({
                currentLanguage: 'fr',
                altLngLabel: 'En'
            });
        }

        this.uri.set('lang', this.state.currentLanguage);
        i18n.changeLanguage(this.state.currentLanguage);
        this.props.history.push("?" + this.uri.toString());
    }

    render() {
        return (
            <Avatar
                className="change-language"
                onClick={this.changeLanguage}>
                {this.state.altLngLabel}
            </Avatar>
        )
    }
}

export default withRouter(withTranslation('appxweb')(AppxLangAvatar));
